@import 'styles/mixins';
@import 'styles/variables';

.field {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;

  .placeholder {
    color: var(--dark-40);
    font-style: normal;
    font-weight: 400;
  }

  &.invalid {
    button {
      outline: 2px solid var(--red-70);
      .placeholder {
        color: var(--red-70);
      }
    }
  }
}

.required {
  color: var(--red-50);
}
